import * as React from 'react'
import { NonThrowingComponent } from '../../../app-core/lib/ui/NonThrowingComponent'

interface Props {
    label?: string
    subtitle: string
}

export class TodoItemSubtitle extends NonThrowingComponent<Props, {}> {
    public tryRender() {
        const { label, subtitle } = this.props
        if (!subtitle) {
            return null
        }
        return (
            <div className="Shared__ellipsis AppCore__ui__TodoItemSubtitle">
                {label && <span className="AppCore__ui__TodoItemSubtitle--label">{label + ': '}</span>}
                {subtitle}
            </div>
        )
    }
}
